<template>
    <div class="kt-header__topbar-item kt-header__topbar-item--user" @click="getnews">
        <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px">
            <span class="kt-header__topbar-welcome kt-visible-desktop">{{ $t('news') }}</span>

            <span
                    class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold"
            >
        <i class="fa fa-bell">{{Count_News_Not_visited}}</i>
      </span>
        </div>
        <div
                class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl"
        >
            <!--begin: Head -->

            <!--end: Head -->

            <!--begin: Navigation -->
            <div class="kt-notification">
                <router-link
                        :to="'/news/'+news.id"
                        class="kt-notification__item"
                        v-bind:key="news.id"
                        v-for="news in newslist"
                >
                    <div class="kt-notification__item-icon">
                        <i class="fa fa-bell see" :class="news.see ? 'see':'dontsee'"></i>
                    </div>
                    <div class="kt-notification__item-details">
                        <div class="kt-notification__item-time">{{news.subject}}</div>
                        <div class="kt-notification__item-title kt-font-bold">{{news.created_at}}</div>
                    </div>
                </router-link>
            </div>

            <!--end: Navigation -->
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";

    export default {
        computed: {
            ...mapState("news", ["newslist", "Count_News_Not_visited"]),
        },
        methods: {
            ...mapActions("news", [
                "getnews",
                "set_Count_News_Not_visited_function",
                "findNewsById",
            ]),
        },
        beforeMount() {
            this.set_Count_News_Not_visited_function();
        },
        updated() {
            this.$route.params.newsid && this.findNewsById(this.$route.params.newsid);
            this.set_Count_News_Not_visited_function();
        },
    };
</script>

<style scoped>
    .see {
        color: #3951c752 !important;
    }
    .dontsee {
        color: #1dc9b7 !important;
    }
</style>>
